import { colors, H4, Text } from "@commonsku/styles";
import React from "react";
import { MapErrorProductType } from "../CheckoutsErrorPopup/CheckoutsErrorPopup";
import { ItemVariant } from "../../../../interfaces/ItemVariant";
interface InnerBodyProps {
  product_name: string;
  product_color: string;
  product_size: string;
  product_sku: string;
  product_error?: string;
  isExternal?: boolean;
}

interface MapCheckoutProductsPopupBarProps {
  product?: MapErrorProductType;
  selectedProduct?: ItemVariant | null;
  selectedProductimgSrc?: string;
  selectedProductItemName?: string;
  isExternal?: boolean;
}
const InnerBody = ({
  product_name,
  product_color,
  product_size,
  product_sku,
  product_error,
  isExternal = false,
}: InnerBodyProps) => {
  return (
    <>
      <H4
        style={{
          fontSize: 16,
          fontWeight: 700,
          color: colors.neutrals[90],
          display: "inline-block",
          marginBottom: 0,
        }}
      >
        {product_name && product_name}
      </H4>
      <Text
        as="span"
        style={{
          display: "inline-block",
          fontWeight: 400,
          fontSize: 14,
        }}
      >
        {product_color && product_color}
        {product_size && `, ${product_size}`}
      </Text>
      <Text
        as="span"
        style={{
          color: isExternal ? colors.errors[50] : colors.secondary3[80],
          display: "inline-block",
          fontWeight: 400,
          fontSize: 14,
        }}
      >
        {product_error && product_error}
        {product_sku && (product_error ? ` - ${product_sku}` : product_sku)}
      </Text>
    </>
  );
};

const MapCheckoutProductsPopupBar = ({
  product,
  selectedProduct,
  selectedProductimgSrc,
  selectedProductItemName,
  isExternal = false,
}: MapCheckoutProductsPopupBarProps) => {
  const selectedProductColor =
    selectedProduct && selectedProduct?.product_sku
      ? JSON.parse(selectedProduct?.product_sku?.sku_options)?.color
      : selectedProduct?.color?.color_name;
  const selectedProductSize =
    selectedProduct && selectedProduct?.product_sku
      ? JSON.parse(selectedProduct?.product_sku?.sku_options)?.size
      : selectedProduct?.size?.size_name;
  const selectedProductSku = selectedProduct && selectedProduct?.external_id;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: selectedProduct
          ? isExternal
            ? "column"
            : "row"
          : "column",
        height: 88,
        padding: 8,
        width: "100%",
        backgroundColor: colors.primary1[20],
        ...(!selectedProduct
          ? { justifyContent: "center" }
          : isExternal
          ? { justifyContent: "center" }
          : { alignItems: "center" }),
        ...(!selectedProduct ? { marginTop: 8 } : {}),
      }}
    >
      {!selectedProduct ? (
        <InnerBody
          product_name={product.product}
          product_color={product.color}
          product_size={product.size}
          product_sku={product.sku}
          product_error={product.errorType}
          isExternal
        />
      ) : !isExternal ? (
        <>
          <img
            src={selectedProductimgSrc}
            style={{
              height: 72,
              width: 72,
              display: "inline-block",
              marginRight: 8,
            }}
            alt={selectedProductItemName}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <InnerBody
              product_name={selectedProductItemName}
              product_color={selectedProductColor}
              product_size={selectedProductSize}
              product_sku={selectedProductSku}
            />
          </div>
        </>
      ) : (
        <InnerBody
          product_name={product.product}
          product_color={product.color}
          product_size={product.size}
          product_sku={product.sku}
          product_error={product.errorType}
          isExternal
        />
      )}
    </div>
  );
};

export default MapCheckoutProductsPopupBar;
